import { render, staticRenderFns } from "./ColorVisualizer.vue?vue&type=template&id=4161a4e3&scoped=true&"
import script from "./ColorVisualizer.vue?vue&type=script&lang=js&"
export * from "./ColorVisualizer.vue?vue&type=script&lang=js&"
import style0 from "./ColorVisualizer.vue?vue&type=style&index=0&id=4161a4e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4161a4e3",
  null
  
)

export default component.exports